import React, { useEffect, useState } from 'react'
import { useIntl } from 'react-intl'
import ItemSelectValueCustomField from './ItemSelectValueCustomField'
import { getSelectedValueCustomFieldPipeline } from '../../functions/helperCustomField'
import { getSelectedValueCustomFieldMerchant } from '../../functions/helperCustomField'
import { MultiSimpleMeeting, SimpleMeeting } from '../../interfaces/Meeting'
import { MultiSimpleMerchant, SimpleMerchant } from '../../interfaces/Merchant'
import { getSelectedValueCustomFieldMeeting } from '../../functions/helperCustomField'
import { MultiSimplePipeline, SimplePipeline } from '../../interfaces/Pipeline'
import { CustomField } from '../../interfaces/Settings'
import { useMeetingStore } from '../../stores/MeetingsStore'
import { useMerchantStore } from '../../stores/MerchantStore'
import { usePipelineStore } from '../../stores/PipelineStore'
import { useUserStore } from '../../stores/UserStore'
import { Modal, Tabs } from 'rsuite'
import { useGeneralStore } from '../../stores/General'
import useExcelStore from '../../stores/Excel'
import { User } from '../../interfaces/User'
import { exportTemplateMerchantExcel } from '../../functions/ExportTemplateExcel/merchant'
import { getCustomFieldFilteredMerchant, getCustomFieldFilteredPipeline, getCustomFieldFilteredUser } from '../../functions/ExportTemplateExcel/functionHelperExcel'
import useNameColumnExcel from '../../hooks/NameColumnExcel'
import { useSettingsStore } from '../../stores/SettingsStore'
import { useDataTableStore } from '../../stores/DataTableStore'
import { useParams } from 'react-router-dom'
import useUser from '../../hooks/User'
import { exportTemplatePipelineExcel } from '../../functions/ExportTemplateExcel/pipeline'
import { exportTemplateUserExcel } from '../../functions/ExportTemplateExcel/user'
import ModalWrapper from '../ModalGeneral/ModalWrapper'
import { truncateText } from '../../functions/general'
import Swal from 'sweetalert2'

interface ModalSelectDataCustomFieldProps {
    customFields: CustomField
    source: 'template-merchant' | 'template-user' | 'template-pipeline' | 'template-unit' | 'template-product',
    typeAction: 'insert' | 'update'
    param: any
    type?: string
}

interface CustomFieldMasterError {
    pipelineError: string[]
    merchantError: string[]
    meetingError: string[]
    userError: string[]
    originalMerchantError: string
}

const ModalSelectDataCustomField = ({ customFields, source, typeAction, param, type }: ModalSelectDataCustomFieldProps) => {
    const intl = useIntl()
    const [initialKeyTab, setInitialKeyTab] = useState<string>('')
    const [tabActive, setTabActive] = useState<string>(source === 'template-pipeline' ? 'originalMerchant' : initialKeyTab)
    const { simplePipelines, multiPipelines, selectMultiPipeline } = usePipelineStore()
    const { simpleMerchants, multiMerchants } = useMerchantStore()
    const { simpleMeetings } = useMeetingStore()
    const [selectedValueCustomFieldMeeting, setSelectedValueCustomFieldMeeting] = useState<MultiSimpleMeeting>({})
    const [selectedValueCustomFieldMerchant, setSelectedValueCustomFieldMerchant] = useState<MultiSimpleMerchant>({})
    const [selectedValueCustomFieldPipeline, setSelectedValueCustomFieldPipeline] = useState<MultiSimplePipeline>({})
    const { users } = useUserStore()
    const { isOpenModalSelectCustomField, setIsOpenModalSelectCustomField, setIsCustomFieldPipeline, setIsCustomFieldMerchant, setIsCustomFieldUser, setIsCustomFieldMeeting, isCustomFieldPipeline, isCustomFieldMerchant, isCustomFieldUser, isCustomFieldMeeting } = useGeneralStore()
    const {
        saveSelectionsToLocalStorage,
        updateTemplateSelections,
        getTemplateSelections
    } = useExcelStore()
    const { filteredTablesData } = useDataTableStore()
    const { settings } = useSettingsStore()
    const [isLoading, setIsLoading] = useState(false)
    const nameHeader: any = useNameColumnExcel();
    const { templatePipelineId, templateMerchantId } = useParams()
    const user = useUser()
    const params = useParams()
    const currentIdTemplate = params['*']?.split('/')[1] || ''
    const [selectedOptions, setSelectedOptions] = useState<Record<string, string[]>>({});
    const [nameCustomFieldErrors, setNameCustomFieldErrors] = useState<CustomFieldMasterError>({
        pipelineError: [],
        merchantError: [],
        meetingError: [],
        userError: [],
        originalMerchantError: ''
    } as CustomFieldMasterError);
    const { errorString, setErrorString } = useGeneralStore()

    const templateSelections = getTemplateSelections(currentIdTemplate) || {
        valueSelectCustomFieldPipeline: {},
        valueSelectCustomFieldMeeting: {},
        valueSelectCustomFieldMerchant: {},
        valueSelectCustomFieldUser: {},
        valueSelectMerchants: []
    };

    // Function to load initial data for custom fields
    useEffect(() => {
        // Initialize the data for all custom fields
        Object.keys(customFields).forEach((key) => {
            if (customFields[key].type === 'pipeline') {
                const filteredPipelines = getSelectedValueCustomFieldPipeline(customFields, simplePipelines, key);
                setSelectedValueCustomFieldPipeline((prevState) => {
                    // Hanya update jika nilainya berbeda
                    if (JSON.stringify(prevState[key]) !== JSON.stringify(filteredPipelines)) {
                        return {
                            ...prevState,
                            [key]: filteredPipelines
                        };
                    }
                    return prevState;
                });
            } else if (customFields[key].type === 'meeting') {
                const filteredMeetings = getSelectedValueCustomFieldMeeting(customFields, simpleMeetings, key);
                setSelectedValueCustomFieldMeeting((prevState) => {
                    // Hanya update jika nilainya berbeda
                    if (JSON.stringify(prevState[key]) !== JSON.stringify(filteredMeetings)) {
                        return {
                            ...prevState,
                            [key]: filteredMeetings
                        };
                    }
                    return prevState;
                });
            } else if (customFields[key].type === 'merchant') {
                const filteredMerchants = getSelectedValueCustomFieldMerchant(customFields, simpleMerchants, key);
                setSelectedValueCustomFieldMerchant((prevState) => {
                    // Hanya update jika nilainya berbeda
                    if (JSON.stringify(prevState[key]) !== JSON.stringify(filteredMerchants)) {
                        return {
                            ...prevState,
                            [key]: filteredMerchants
                        };
                    }
                    return prevState;
                });
            }
        });
    }, [customFields, simplePipelines, simpleMeetings, simpleMerchants]);

    const handleButton = () => {
        setIsLoading(true)
        if (nameCustomFieldErrors.pipelineError.length > 0 || nameCustomFieldErrors.merchantError.length > 0 || nameCustomFieldErrors.meetingError.length > 0 || nameCustomFieldErrors.userError.length > 0 || nameCustomFieldErrors.originalMerchantError) {
            const nameCustomFieldsErrors = []
            if (nameCustomFieldErrors.originalMerchantError.length > 0) {
                nameCustomFieldsErrors.push(nameCustomFieldErrors.originalMerchantError)
            } if (nameCustomFieldErrors.pipelineError.length > 0) {
                nameCustomFieldsErrors.push(...nameCustomFieldErrors.pipelineError.map((item: string) => item))
            } if (nameCustomFieldErrors.merchantError.length > 0) {
                nameCustomFieldsErrors.push(...nameCustomFieldErrors.merchantError.map((item: string) => item))
            } if (nameCustomFieldErrors.meetingError.length > 0) {
                nameCustomFieldsErrors.push(...nameCustomFieldErrors.meetingError.map((item: string) => item))
            } if (nameCustomFieldErrors.userError.length > 0) {
                nameCustomFieldsErrors.push(...nameCustomFieldErrors.userError.map((item: string) => item))
            }

            Swal.fire({
                icon: 'error',
                title: intl.formatMessage({ id: 'FORM.VALIDATION.DOWNLOAD_TEMPLATE_FAILED' }),
                html: intl.formatMessage({ id: "FORM.VALIDATION.NO_CHOSEN_DATA" }) +
                    `
                    <div class="d-flex justify-content-center">
                        <ul class="d-flex flex-column justify-content-start mt-2">
                            ${nameCustomFieldsErrors.map((item: string) => `<li>${item}</li>`).join('')}
                        </ul>
                    </div>
                    `
                    + intl.formatMessage({ id: "FORM.VALIDATION.COMPLETE_THIS_FIRST" }),
                text: intl.formatMessage({ id: 'FORM.VALIDATION.COMPLETE_THIS_FIRST' }),
                confirmButtonText: intl.formatMessage({ id: 'FORM.CONFIRMATION.OK' }),
            });
            setIsLoading(false)
            return
        }

        if (source === 'template-merchant') {
            const filteredCustomFieldMerchant = getCustomFieldFilteredMerchant(templateMerchantId as string, multiMerchants, user)

            if (typeAction === 'insert') {
                setTimeout(() => exportTemplateMerchantExcel({
                    nameFile: intl.formatMessage({ id: 'FORM.LABEL.TITLE_FILE_EXCEL' }, { title1: intl.formatMessage({ id: 'FORM.ACTION.ADD' }), title2: settings.merchant_title }),
                    customFields: filteredCustomFieldMerchant,
                    source,
                    typeAction,
                    settings,
                    nameInfo: `Template Insert Merchant ${templateMerchantId}`,
                    nameHeader: nameHeader.import,
                    setIsLoading,
                    simpleCustomFieldsMaster: {
                        pipelines: templateSelections.valueSelectCustomFieldPipeline,
                        meetings: templateSelections.valueSelectCustomFieldMeeting,
                        merchants: templateSelections.valueSelectCustomFieldMerchant,
                        users: templateSelections.valueSelectCustomFieldUser
                    },
                    user: user,
                    param,
                    type,
                    intl
                }), 100)
                saveSelectionsToLocalStorage();
            } else if (typeAction === 'update') {
                setTimeout(() => exportTemplateMerchantExcel({
                    nameFile: intl.formatMessage({ id: 'FORM.LABEL.TITLE_FILE_ERROR' }, { title1: intl.formatMessage({ id: 'FORM.ACTION.UPDATE' }), title2: settings.merchant_title }),
                    customFields: filteredCustomFieldMerchant,
                    source,
                    typeAction,
                    settings,
                    nameInfo: `Template Error Update Merchant ${templateMerchantId}`,
                    nameHeader: nameHeader.import,
                    setIsLoading,
                    simpleCustomFieldsMaster: {
                        pipelines: templateSelections.valueSelectCustomFieldPipeline,
                        meetings: templateSelections.valueSelectCustomFieldMeeting,
                        merchants: templateSelections.valueSelectCustomFieldMerchant,
                        users: templateSelections.valueSelectCustomFieldUser
                    },
                    user: user,
                    param: { ...param, dataTables: filteredTablesData[`merchants`] },
                    type,
                    intl
                }), 100)
                saveSelectionsToLocalStorage();
            }
        } else if (source === 'template-user') {
            const filteredCustomFieldUser = getCustomFieldFilteredUser(customFields)

            if (typeAction === 'insert') {
                setTimeout(() => exportTemplateUserExcel({
                    nameFile: intl.formatMessage({ id: 'FORM.LABEL.TITLE_FILE_EXCEL' }, { title1: intl.formatMessage({ id: 'FORM.ACTION.ADD' }), title2: intl.formatMessage({ id: 'FORM.LABEL.USER' }) }),
                    customFields: filteredCustomFieldUser,
                    source,
                    typeAction,
                    settings,
                    nameInfo: 'Template Insert User',
                    nameHeader: nameHeader.import,
                    setIsLoading,
                    simpleCustomFieldsMaster: {
                        pipelines: templateSelections.valueSelectCustomFieldPipeline,
                        meetings: templateSelections.valueSelectCustomFieldMeeting,
                        merchants: templateSelections.valueSelectCustomFieldMerchant,
                        users: templateSelections.valueSelectCustomFieldUser
                    },
                    user: user,
                    param,
                    type,
                    intl
                }), 100)
                saveSelectionsToLocalStorage();
            } else if (typeAction === 'update') {
                setTimeout(() => exportTemplateUserExcel({
                    nameFile: intl.formatMessage({ id: 'FORM.LABEL.TITLE_FILE_EXCEL' }, { title1: intl.formatMessage({ id: 'FORM.ACTION.UPDATE' }), title2: intl.formatMessage({ id: 'FORM.LABEL.USER' }) }),
                    customFields: filteredCustomFieldUser,
                    source,
                    typeAction,
                    settings,
                    nameInfo: 'Template Error Update User',
                    nameHeader: nameHeader.import,
                    setIsLoading,
                    simpleCustomFieldsMaster: {
                        pipelines: templateSelections.valueSelectCustomFieldPipeline,
                        meetings: templateSelections.valueSelectCustomFieldMeeting,
                        merchants: templateSelections.valueSelectCustomFieldMerchant,
                        users: templateSelections.valueSelectCustomFieldUser
                    },
                    user: user,
                    param: { ...param, dataTables: filteredTablesData['users'] },
                    type,
                    intl
                }), 100)
                saveSelectionsToLocalStorage();
            }
        } else if (source === 'template-pipeline') {
            const filteredCustomFieldPipeline = getCustomFieldFilteredPipeline(templatePipelineId as string, multiPipelines, user!)

            if (typeAction === 'insert') {
                setTimeout(() => exportTemplatePipelineExcel({
                    nameFile: intl.formatMessage({ id: 'FORM.LABEL.TITLE_FILE_EXCEL' }, { title1: intl.formatMessage({ id: 'FORM.ACTION.ADD' }), title2: settings.pipeline_title + "-" + selectMultiPipeline.name }),
                    customFields: filteredCustomFieldPipeline,
                    source,
                    typeAction,
                    settings,
                    nameInfo: `Template Insert Pipeline ${templatePipelineId}`,
                    nameHeader: nameHeader.import,
                    setIsLoading,
                    simpleCustomFieldsMaster: {
                        pipelines: templateSelections.valueSelectCustomFieldPipeline,
                        meetings: templateSelections.valueSelectCustomFieldMeeting,
                        merchants: templateSelections.valueSelectCustomFieldMerchant,
                        users: templateSelections.valueSelectCustomFieldUser
                    },
                    user: user,
                    param,
                    type,
                    dataMerchants: templateSelections.valueSelectMerchants || simpleMerchants,
                    intl
                }), 100)
                saveSelectionsToLocalStorage();
            } else if (typeAction === 'update') {
                setTimeout(() => exportTemplatePipelineExcel({
                    nameFile: intl.formatMessage({ id: 'FORM.LABEL.TITLE_FILE_EXCEL' }, { title1: intl.formatMessage({ id: 'FORM.ACTION.UPDATE' }), title2: settings.pipeline_title }),
                    customFields: filteredCustomFieldPipeline,
                    source,
                    typeAction,
                    settings,
                    nameInfo: `Template Update Pipeline ${templatePipelineId}`,
                    nameHeader: nameHeader.import,
                    setIsLoading,
                    simpleCustomFieldsMaster: {
                        pipelines: templateSelections.valueSelectCustomFieldPipeline,
                        meetings: templateSelections.valueSelectCustomFieldMeeting,
                        merchants: templateSelections.valueSelectCustomFieldMerchant,
                        users: templateSelections.valueSelectCustomFieldUser
                    },
                    user: user,
                    param: { ...param, dataTables: filteredTablesData['pipeline'] },
                    type,
                    dataMerchants: templateSelections.valueSelectMerchants || simpleMerchants,
                    intl
                }), 100)
                saveSelectionsToLocalStorage();
            }
        }
    }

    // Initialize selected options from template selections
    useEffect(() => {
        const initialSelectedOptions: Record<string, string[]> = {};
        // Dapatkan selections dari store hanya sekali per render
        const templateSelections = getTemplateSelections(currentIdTemplate) || {
            valueSelectCustomFieldPipeline: {},
            valueSelectCustomFieldMeeting: {},
            valueSelectCustomFieldMerchant: {},
            valueSelectCustomFieldUser: {},
            valueSelectMerchants: []
        };

        // Initialize originalMerchant
        if (templateSelections.valueSelectMerchants?.length > 0) {
            initialSelectedOptions['originalMerchant'] = templateSelections.valueSelectMerchants.map(m => m.id);
        }

        Object.keys(customFields).forEach(key => {
            const field = customFields[key];
            const required = customFields[key].required;

            if (field.type === 'pipeline' && templateSelections.valueSelectCustomFieldPipeline?.[key]) {
                initialSelectedOptions[key] = templateSelections.valueSelectCustomFieldPipeline[key]
                    .map((item: SimplePipeline) => item.id);
                if ((templateSelections.valueSelectCustomFieldPipeline?.[key] as SimplePipeline[] || []).length === 0 && required) {
                    setNameCustomFieldErrors(prev => ({
                        ...prev,
                        pipelineError: [...prev.pipelineError, customFields[key].name]
                    }));
                } else {
                    setNameCustomFieldErrors(prev => ({
                        ...prev,
                        pipelineError: prev.pipelineError?.filter(item => item !== customFields[key].name)
                    }));
                }
            } else if (field.type === 'meeting' && templateSelections.valueSelectCustomFieldMeeting?.[key]) {
                initialSelectedOptions[key] = templateSelections.valueSelectCustomFieldMeeting[key]
                    .map((item: SimpleMeeting) => item.id);
                if ((templateSelections.valueSelectCustomFieldMeeting?.[key] as SimpleMeeting[] || []).length === 0 && required) {
                    setNameCustomFieldErrors(prev => ({
                        ...prev,
                        meetingError: [...prev.meetingError, customFields[key].name]
                    }));
                } else {
                    setNameCustomFieldErrors(prev => ({
                        ...prev,
                        meetingError: prev.meetingError?.filter(item => item !== customFields[key].name)
                    }));
                }
            } else if (field.type === 'merchant' && templateSelections.valueSelectCustomFieldMerchant?.[key]) {
                initialSelectedOptions[key] = templateSelections.valueSelectCustomFieldMerchant[key]
                    .map((item: SimpleMerchant) => item.id);
                if ((templateSelections.valueSelectCustomFieldMerchant?.[key] as SimpleMerchant[] || []).length === 0 && required) {
                    setNameCustomFieldErrors(prev => ({
                        ...prev,
                        merchantError: [...prev.merchantError, customFields[key].name]
                    }));
                } else {
                    setNameCustomFieldErrors(prev => ({
                        ...prev,
                        merchantError: prev.merchantError?.filter(item => item !== customFields[key].name)
                    }));
                }
            } else if (field.type === 'user' && templateSelections.valueSelectCustomFieldUser?.[key]) {
                initialSelectedOptions[key] = templateSelections.valueSelectCustomFieldUser[key]
                    .map((item: User) => item.id);
                if ((templateSelections.valueSelectCustomFieldUser?.[key] as User[] || []).length === 0 && required) {
                    setNameCustomFieldErrors(prev => ({
                        ...prev,
                        userError: [...prev.userError, customFields[key].name]
                    }));
                } else {
                    setNameCustomFieldErrors(prev => ({
                        ...prev,
                        userError: prev.userError?.filter(item => item !== customFields[key].name)
                    }));
                }
            } else if (source === 'template-pipeline') {
                if (templateSelections.valueSelectMerchants.length === 0) {
                    setNameCustomFieldErrors(prev => ({
                        ...prev,
                        originalMerchantError: settings.merchant_title
                    }));
                } else {
                    setNameCustomFieldErrors(prev => ({
                        ...prev,
                        originalMerchantError: ""
                    }));
                }
            }
        });

        // Bandingkan dengan nilai sebelumnya untuk menghindari infinite loop
        setSelectedOptions(prevOptions => {
            if (JSON.stringify(prevOptions) !== JSON.stringify(initialSelectedOptions)) {
                return initialSelectedOptions;
            }
            return prevOptions;
        });

        return () => {
            setNameCustomFieldErrors({ pipelineError: [], merchantError: [], meetingError: [], userError: [], originalMerchantError: "" });
        }
    }, [selectedOptions]);

    const handleTabChange = (eventKey: string | number | undefined) => {
        if (typeof eventKey === 'string') {
            setTabActive(eventKey);
        }
    };

    useEffect(() => {
        if (errorString) {
            Swal.fire({
                icon: 'error',
                title: 'Error',
                text: errorString
            })
            setIsLoading(false)
        }

        return () => {
            setErrorString('');
        }
    }, [errorString])

    const handleSaveSelections = async () => {
        handleButton();
    };

    const handleClose = () => {
        setIsOpenModalSelectCustomField(false);
        setIsCustomFieldPipeline(false);
        setIsCustomFieldMerchant(false);
        setIsCustomFieldUser(false);
        setIsCustomFieldMeeting(false);
    };

    // Update style for tabs to display properly
    useEffect(() => {
        const getClassRsNav = document.querySelector('.rs-nav') as HTMLElement;
        if (getClassRsNav) {
            getClassRsNav.style.display = 'flex';
            getClassRsNav.style.flexWrap = 'wrap';
            getClassRsNav.style.gap = '3px';
        }
    }, []);

    // Function to handle selected options change
    const handleSelectedOptionsChange = (customFieldId: string, options: string[]) => {
        setSelectedOptions(prev => ({
            ...prev,
            [customFieldId]: options
        }));

        if (customFieldId === 'originalMerchant') {
            const newValues = simpleMerchants.filter(merchant => options.includes(merchant.id));
            updateTemplateSelections(currentIdTemplate, 'originalMerchant', { valueSelectMerchants: newValues });
        } else {
            Object.keys(customFields).forEach(key => {
                if (key === customFieldId) {
                    const field = customFields[key];

                    if (field.type === 'pipeline') {
                        const newValues = simplePipelines.filter(pipeline => options.includes(pipeline.id));
                        updateTemplateSelections(currentIdTemplate, key, { valueSelectCustomFieldPipeline: newValues });
                    } else if (field.type === 'meeting') {
                        const newValues = simpleMeetings.filter(meeting => options.includes(meeting.id));
                        updateTemplateSelections(currentIdTemplate, key, { valueSelectCustomFieldMeeting: newValues });
                    } else if (field.type === 'merchant') {
                        const newValues = simpleMerchants.filter(merchant => options.includes(merchant.id));
                        updateTemplateSelections(currentIdTemplate, key, { valueSelectCustomFieldMerchant: newValues });
                    } else if (field.type === 'user') {
                        const newValues = users.filter(user => options.includes(user.id));
                        updateTemplateSelections(currentIdTemplate, key, { valueSelectCustomFieldUser: newValues });
                    }
                }
            });
        }
    };

    useEffect(() => {
        if (customFields) {
            const filteredCustomFields = Object.keys(customFields).filter(key => {
                const field = customFields[key];
                return field.type === 'pipeline' || field.type === 'meeting' || field.type === 'merchant' || field.type === 'user';
            });
            if (filteredCustomFields.length > 0) {
                setInitialKeyTab(filteredCustomFields[0]);
            }
        }
    }, [])

    useEffect(() => {
        if (initialKeyTab && source !== 'template-pipeline') {
            setTabActive(initialKeyTab);
        }
    }, [initialKeyTab]);

    const tabTitleMerchant = (title: string) => {
        return (
            <>
                {title} <span style={{ color: 'red' }}>*</span>
            </>
        )
    }

    const renderTabsContent = () => {
        let hasTabsToRender = source === 'template-pipeline'; // Always true for template-pipeline

        if (!hasTabsToRender) {
            Object.keys(customFields).forEach(key => {
                const field = customFields[key];
                if (field.type === 'pipeline' || field.type === 'meeting' ||
                    field.type === 'merchant' || field.type === 'user') {
                    hasTabsToRender = true;
                }
            });
        }

        if (!hasTabsToRender) {
            return (
                <div className="alert alert-info text-center">
                    <i className="fas fa-info-circle me-2"></i>
                    {intl.formatMessage({ id: 'FORM.INFO.NO_CUSTOM_FIELDS' },
                        { defaultMessage: 'Tidak ada custom field yang tersedia untuk template ini.' })}
                </div>
            );
        }

        return (
            <Tabs
                activeKey={tabActive}
                onSelect={handleTabChange}
                appearance="subtle"
            >
                {source === 'template-pipeline' && (
                    <Tabs.Tab eventKey="originalMerchant" title={tabTitleMerchant(truncateText(settings.merchant_title, 20))}>
                        <ItemSelectValueCustomField
                            valueSelectOptionCustomField={{
                                defaultMerchant: simpleMerchants,
                            }}
                            source={source}
                            customFieldGeneral={customFields}
                            activeTab="originalMerchant"
                            placeholder={`${intl.formatMessage({ id: "FORM.ACTION.CHOOSE" })} ${truncateText(settings.merchant_title, 20)}`}
                            valuesKey={selectedOptions['originalMerchant'] || []}
                            onSelectedOptionsChange={handleSelectedOptionsChange}
                        />
                    </Tabs.Tab>
                )}

                {Object.keys(customFields).map(key => {
                    const field = customFields[key];
                    let renderTab = false;
                    let tabTitle: any = "";
                    let placeholder = "";
                    let valueOptions = {};
                    let isRequired = false;

                    if (field.type === 'pipeline') {
                        renderTab = true;
                        tabTitle = `${truncateText(field.name, 20)} (${intl.formatMessage({ id: "FORM.LABEL.CUSTOM" })})`;
                        placeholder = `${intl.formatMessage({ id: "FORM.ACTION.CHOOSE" })} ${truncateText(field.name, 20)}`;
                        valueOptions = { pipeline: selectedValueCustomFieldPipeline[key] || [] };
                        isRequired = field.required;
                    } else if (field.type === 'meeting') {
                        renderTab = true;
                        tabTitle = `${truncateText(field.name, 20)} (${intl.formatMessage({ id: "FORM.LABEL.CUSTOM" })})`;
                        placeholder = `${intl.formatMessage({ id: "FORM.ACTION.CHOOSE" })} ${truncateText(field.name, 20)}`;
                        valueOptions = { meeting: selectedValueCustomFieldMeeting[key] || [] };
                        isRequired = field.required;
                    } else if (field.type === 'merchant') {
                        renderTab = true;
                        tabTitle = `${truncateText(field.name, 20)} (${intl.formatMessage({ id: "FORM.LABEL.CUSTOM" })})`;
                        placeholder = `${intl.formatMessage({ id: "FORM.ACTION.CHOOSE" })} ${truncateText(field.name, 20)}`;
                        valueOptions = { merchant: selectedValueCustomFieldMerchant[key] || [] };
                        isRequired = field.required;
                    } else if (field.type === 'user') {
                        renderTab = true;
                        tabTitle = `${truncateText(field.name, 20)} (${intl.formatMessage({ id: "FORM.LABEL.CUSTOM" })})`;
                        placeholder = `${intl.formatMessage({ id: "FORM.ACTION.CHOOSE" })} ${truncateText(field.name, 20)}`;
                        valueOptions = { user: users };
                        isRequired = field.required;
                    }

                    if (isRequired) {
                        tabTitle = (
                            <>
                                {tabTitle} <span style={{ color: 'red' }}>*</span>
                            </>
                        );
                    }

                    if (renderTab) {
                        return (
                            <Tabs.Tab eventKey={key} title={tabTitle} key={key}>
                                <ItemSelectValueCustomField
                                    valueSelectOptionCustomField={valueOptions}
                                    source={source}
                                    customFieldGeneral={customFields}
                                    activeTab={key}
                                    placeholder={placeholder}
                                    valuesKey={selectedOptions[key] || []}
                                    onSelectedOptionsChange={handleSelectedOptionsChange}
                                    isRequired={isRequired}
                                    typeMultiValue={(field.type === 'pipeline' ? 'pipeline' : field.type === 'meeting' ? 'meeting' : 'default')}
                                />
                            </Tabs.Tab>
                        );
                    }

                    return null;
                })}
            </Tabs>
        );
    };

    return (
        <Modal open={isOpenModalSelectCustomField} onClose={handleClose} size={'lg'}>
            <div className='modal-header'>
                <h5 className='modal-title'>{intl.formatMessage({ id: "FORM.LABEL.DOWNLOAD_EXCEL" })}</h5>
            </div>
            <div className='modal-body' style={{ minHeight: '450px' }}>
                <style>
                    {`
                        .rs-nav-tabs {
                            border-bottom: none !important;
                        }
                        .rs-nav-item {
                            border: none !important;
                        }
                        .rs-nav-item.rs-nav-item-active {
                            border-bottom: 1px solid #1675e0 !important;
                        }
                        .rs-nav-item:hover {
                            border-bottom: 1px solid #1675e0 !important;
                        }
                    `}
                </style>
                <p className='text-start'>{intl.formatMessage({ id: "FORM.LABEL.SELECT_VALUE_DESCRIPTION" })}</p>
                {renderTabsContent()}
            </div>
            <div className='modal-footer'>
                <button className='btn btn-secondary me-3'
                    data-bs-toggle="modal"
                    data-bs-target={`#import-excel-${source}-modal`}
                    onClick={handleClose}>
                    {intl.formatMessage({ id: 'FORM.ACTION.CLOSE' })}
                </button>
                <button className={`btn btn-success skeleton skeleton-button ${isLoading ? 'disabled' : ""}`} data-kt-indicator={isLoading ? 'on' : 'off'} onClick={handleSaveSelections}>
                    <i className="fas fa-file-download fs-2 me-2"></i>
                    <span className="indicator-label">
                        {intl.formatMessage({ id: 'FORM.ACTION.SAVE_AND_DOWNLOAD' })}
                    </span>
                    <span className="indicator-progress">
                        Loading... &nbsp;
                        <span className="spinner-border spinner-border-sm align-middle ms-2"></span>
                    </span>
                </button>
            </div>
        </Modal>
    )
}

export default ModalSelectDataCustomField